import React from 'react';

import type { IntlShape } from 'react-intl-next';

import type { EditorView } from '@atlaskit/editor-prosemirror/view';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import { HandleActionType, type BaseConversationAction, type ConversationAction } from '@atlassian/rovo-conversation-actions';

import type { AIGlobalOptIn } from '../../../types/types';
import type { EditorPluginAIConfigItemWithOptions } from '../../../ui/prebuilt/config-items/config-items';
import { createOpenAIModalCommand } from '../../decoration/actions';

export const createGetNudgeFromConfigItem = ({
	editorView,
	configItem,
	aiGlobalOptIn,
	intl,
}: {
	aiGlobalOptIn: AIGlobalOptIn;
	configItem: EditorPluginAIConfigItemWithOptions;
	editorView: EditorView;
	intl: IntlShape;
}): ((nudgeMetrics?: Record<string, number | undefined>) => ConversationAction) => {
	return (nudgeMetrics?: Record<string, number | undefined>): BaseConversationAction => ({
		id: configItem.config.key,
		title: intl.formatMessage(configItem.config.title),
		description: intl.formatMessage(configItem.config.description),
		icon: () => configItem.config.icon?.({ formatMessage: intl.formatMessage }) || (
			<AtlassianIntelligenceIcon label="" spacing="spacious" />
		),
		onClick: () => {
			editorView.focus();
			createOpenAIModalCommand({
				state: editorView.state,
				configItem: configItem.config,
				lastTriggeredFrom: 'rovoButtonNudge',
				nudgeMetrics,
				aiGlobalOptIn,
				locale: intl.locale,
			})(editorView.state, editorView.dispatch);
		},
		handleType: HandleActionType.Base,
		type: 'ai-action',
	});
};
